import React from "react";
import { Form, Input } from "antd";

export default function SupplierForm({ form }) {
  return (
    <Form form={form} layout="vertical" requiredMark={false}>
      <Form.Item
        name="name"
        label="Назва"
        rules={[{ required: true, message: "Вкажіть назву (мін. 2 символи)", min: 2 }]}
      >
        <Input placeholder="Назва постачальника" autoFocus />
      </Form.Item>

      <Form.Item name="phone" label="Телефон">
        <Input placeholder="+380..." />
      </Form.Item>

      <Form.Item name="country" label="Країна">
        <Input placeholder="Україна" />
      </Form.Item>

      <Form.Item name="note" label="Примітка">
        <Input.TextArea placeholder="Додаткова інформація" rows={4} />
      </Form.Item>
    </Form>
  );
}
